import React from 'react';
import { motion } from 'framer-motion';
import { Search, Upload, FileText, Image as ImageIcon, FileSignature, MoreHorizontal } from 'lucide-react';
const assets = [{
  name: 'Standard Performance Contract v3.2',
  type: 'Contract',
  icon: <FileSignature className="w-5 h-5 text-purple-500" data-id="element-1962" />,
  updated: 'Updated 2 weeks ago',
  current: true
}, {
  name: 'Technical Rider 2026',
  type: 'Rider',
  icon: <FileText className="w-5 h-5 text-blue-500" data-id="element-1963" />,
  updated: 'Updated 1 month ago',
  current: true
}, {
  name: 'Press Kit',
  type: 'Document',
  icon: <FileText className="w-5 h-5 text-textMuted" data-id="element-1964" />,
  updated: 'Updated 3 months ago',
  current: false
}, {
  name: 'Stage Plot',
  type: 'Document',
  icon: <FileText className="w-5 h-5 text-textMuted" data-id="element-1965" />,
  updated: 'Updated 2 months ago',
  current: true
}, {
  name: 'W-9 Form',
  type: 'Document',
  icon: <FileText className="w-5 h-5 text-textMuted" data-id="element-1966" />,
  updated: 'Updated 6 months ago',
  current: false
}, {
  name: 'Logo Pack',
  type: 'Images',
  icon: <ImageIcon className="w-5 h-5 text-green-500" data-id="element-1967" />,
  updated: 'Updated 1 year ago',
  current: false
}];
export function AssetsPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-1968">
      {/* Header & Tabs */}
      <div className="mb-6" data-id="element-1969">
        <div className="flex justify-between items-center mb-6" data-id="element-1970">
          <h2 className="text-2xl font-bold" data-id="element-1971">Assets & Library</h2>
          <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-1972">
            <Upload className="w-4 h-4" data-id="element-1973" />
            Upload File
          </button>
        </div>
        <div className="flex gap-6 border-b border-border" data-id="element-1974">
          <button className="pb-3 text-sm font-medium text-textMuted hover:text-textMain transition-colors" data-id="element-1975">
            Images
          </button>
          <button className="pb-3 text-sm font-medium text-primary border-b-2 border-primary" data-id="element-1976">
            Documents
          </button>
          <button className="pb-3 text-sm font-medium text-textMuted hover:text-textMain transition-colors" data-id="element-1977">
            Riders
          </button>
          <button className="pb-3 text-sm font-medium text-textMuted hover:text-textMain transition-colors" data-id="element-1978">
            Contracts
          </button>
          <button className="pb-3 text-sm font-medium text-textMuted hover:text-textMain transition-colors" data-id="element-1979">
            Promo Copy
          </button>
          <button className="pb-3 text-sm font-medium text-textMuted hover:text-textMain transition-colors" data-id="element-1980">
            Media Links
          </button>
        </div>
      </div>

      {/* Search */}
      <div className="mb-6" data-id="element-1981">
        <div className="relative max-w-md" data-id="element-1982">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-1983" />
          <input type="text" placeholder="Search documents..." className="w-full pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-1984" />
        </div>
      </div>

      {/* Asset Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1985">
        {assets.map((asset, i) => <div key={i} className="bg-surface border border-border rounded-xl p-5 hover:border-primary/50 transition-colors cursor-pointer group flex flex-col" data-id="element-1986">
            <div className="flex justify-between items-start mb-4" data-id="element-1987">
              <div className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center" data-id="element-1988">
                {asset.icon}
              </div>
              <button className="p-1 text-textMuted hover:text-textMain transition-colors rounded hover:bg-background opacity-0 group-hover:opacity-100" data-id="element-1989">
                <MoreHorizontal className="w-4 h-4" data-id="element-1990" />
              </button>
            </div>

            <h3 className="font-medium text-sm mb-1 group-hover:text-primary transition-colors line-clamp-1" title={asset.name} data-id="element-1991">
              {asset.name}
            </h3>

            <div className="flex items-center justify-between mt-auto pt-4" data-id="element-1992">
              <span className="text-xs text-textMuted" data-id="element-1993">{asset.updated}</span>
              {asset.current && <span className="px-2 py-0.5 bg-primary/10 text-primary text-[10px] uppercase tracking-wider font-bold rounded" data-id="element-1994">
                  Current
                </span>}
            </div>
          </div>)}
      </div>
    </motion.div>;
}